export enum ContactConfirmationChannel {
  EMAIL = 'EMAIL',
  WHATSAPP = 'WHATSAPP',
}

export default interface ContactConfirmationResponse {
  channel: ContactConfirmationChannel;
}
